/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AnalyticExportRow } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface AnalyticExportServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Returns content of analytic export data based on analyticvalueid
     * Returns content of analytic export data based on analyticvalueid
     * @param requestBody 
     */
    getAnalyticExportContent(requestBody?: { [key: string]: any; }, extraHttpRequestParams?: any): Observable<Array<AnalyticExportRow>>;

}
